import styled from 'styled-components'

export const ResourceCardContainer = styled.div`
  width: 300px;
  min-width: 300px;
  border-radius: 6px;
  background-color: ${({ theme }) => theme.colors.foregroundPaper};
  display: flex;
  flex-direction: column;
  padding: 0;
  margin: 4px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
`

export const CardHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  padding: 12px 12px 4px 12px;
`

export const CardBody = styled.div`
  padding: 0 12px 8px 12px;
`

export const CardFooter = styled.div`
  padding: 8px 12px 12px 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const Title = styled.span`
  font-weight: bold;
  flex: 1;
  font-size: 16px;
  color: ${({ theme }) => theme.colors.text};
  line-height: 1.3;
`

export const Label = styled.span`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.info};
  min-width: 70px;
`
export const Value = styled.span`
  font-weight: bold;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.text};
`

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`

export const Subtitle = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.info};
`

export const AssigneesContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`

export const CarHeaderAndBodyContainer = styled.div`
  display: flex;
  flex-direction: column;
`
